import React from "react";
import { graphql } from "gatsby";
import {
  Container,
  SignUpForm,
  Seo
} from "../components";
import { PageStayInformedStyles } from "../styles";

const Signup = ({ data }) => {
  const dataQuery = data.allMarkdownRemark.nodes[0],
        componentID = data.allMarkdownRemark.nodes[0].frontmatter.components_id,
        markdownID = `signup-content`;

  return (
    <>
      <Container markdownID={markdownID} componentID={componentID} query={dataQuery} noSubNav={true}>
        <PageStayInformedStyles id={`main`} className={`form-wrapper`}>
          <div className="md-container">
            <SignUpForm />
          </div>
        </PageStayInformedStyles>
      </Container>
    </>
  );
};

export const query = graphql`
  {
    allMarkdownRemark(filter: { frontmatter: { markdown_id: { eq: "signup-content" } } }) {
      nodes {
        frontmatter {
          slug
          description
          keywords
          markdown_id
          title
          components_id
          definitions
          footnotes
          references
          canonicalUrl
          url
          ogTitle
          ogDescription
          ogUrl
          ogImage
          ogImageAlt
        }
        id
        html
      }
    }
  }
`;

export const Head = ({ data }) => ( <Seo properties={data.allMarkdownRemark.nodes[0].frontmatter} /> );

export default Signup;
